(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    const moveThrillSizingContent = () => {
    document.querySelectorAll('[data-thrill-sizing-slot]').forEach((slot) => {
      if (slot.dataset.thrillSizingReady === 'true') return;

      const productDetails = slot.closest('.product-details');
      if (!productDetails) return;

      const sizeGuide = productDetails.querySelector('.thrill-size-guide');
      if (!sizeGuide) return;

      const sizeFitStrong = Array.from(productDetails.querySelectorAll('strong')).find((element) =>
        /^size\s*&\s*fit\s*:/i.test((element.textContent || '').trim())
      );

      if (sizeFitStrong) {
        const paragraph = sizeFitStrong.closest('p');

        if (paragraph) {
          while (sizeFitStrong.previousSibling && sizeFitStrong.previousSibling.nodeName === 'BR') {
            sizeFitStrong.previousSibling.remove();
          }

          const fitCopy = document.createElement('p');
          fitCopy.className = 'thrill-sizing-fit';

          let node = sizeFitStrong;
          while (node) {
            const next = node.nextSibling;
            fitCopy.appendChild(node);
            node = next;
          }

          slot.appendChild(fitCopy);

          if (!paragraph.textContent?.trim() && !paragraph.querySelector('*')) {
            paragraph.remove();
          }
        }
      }

      slot.appendChild(sizeGuide);
      slot.dataset.thrillSizingReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveThrillSizingContent, { once:true });
  } else {
    moveThrillSizingContent();
  }

  document.addEventListener('shopify:section:load', moveThrillSizingContent);
  } catch(e) { console.error(e); }
})();

})();
